/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Import each symbol from its clean subpath instead, e.g. `import { UFOExperience } from '@atlassian/ufo-experimental/experience'`, `import { ConcurrentExperience } from '@atlassian/ufo-experimental/concurrent-experience'`, `import { perfNowOrTimestamp } from '@atlassian/ufo-experimental/perf-now-or-timestamp'`.
 */
export {
	UFOExperienceState,
	UFOExperience,
	ConcurrentExperience,
	ExperienceTypes,
	ExperiencePerformanceTypes,
	GlobalPageLoadExperience,
	type AbstractExperienceConfig,
	perfNowOrTimestamp,
	type EndStateConfig,
} from './core';

/**
 * @deprecated Use `import { useUFOExperience } from '@atlassian/ufo-experimental/use-ufo-experience'` instead.
 */
export { useUFOExperience } from './hooks/useUFOExperience';
/**
 * @deprecated Use `import { useUFOStreamingExperience } from '@atlassian/ufo-experimental/use-ufo-streaming-experience'` instead.
 */
export { useUFOStreamingExperience } from './hooks/useUFOStreamingExperience';
